import { createRoute } from '@tanstack/react-router';
import type { EzyModule } from '../module';
import { HsAdvice } from './HsAdvice';

// Tư vấn HS (O-01). Vào từ Dịch vụ, không thêm mục menu.
const hs: EzyModule = {
  routes: (parent) => [createRoute({ getParentRoute: () => parent, path: '/hs', component: HsAdvice })],
};
export default hs;
